import * as Sentry from "@sentry/react";
import fetchWithRefresh from "./fetchWithRefresh";

export const LogErrors = async ( user, logout, updateTokens, error) => {

    await Sentry.startSpan(
        { name: "Log PWA Error", op: "http.request" },
        async (span) => {
          try {
            const response = await fetchWithRefresh( import.meta.env.VITE_API_URL + `Error/LogPWAError/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${user.token}`,
                    },
                    body: JSON.stringify(error)
                },
                logout,
                updateTokens,
                (message) => {
                    toast.info(message);
                }
            );

            span.setAttribute("http.status_code", response.status);
            if (!response.ok) {
              span.setStatus("error");
            }
          } catch (error) {
            span.setStatus("error");
            Sentry.captureException(error);
            console.log("Error logging error", error);
          } finally {
            span.end();
          }
        }
    );
};